import { render, staticRenderFns } from "./SnHeader.vue?vue&type=template&id=513a2b76&scoped=true"
import script from "./SnHeader.vue?vue&type=script&lang=js"
export * from "./SnHeader.vue?vue&type=script&lang=js"
import style0 from "./SnHeader.vue?vue&type=style&index=0&id=513a2b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513a2b76",
  null
  
)

export default component.exports